/* eslint-disable no-unused-vars */
// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Images
import qrCode from "assets/images/WhatsApp_QR.jpg";

// Reusable Components
import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import Email from "reusables/Contact/Email";

function ContactUs_Section1() {
  return (
    <Container>
      <Grid container alignItems="center" width={"100%"} rowSpacing={2}>
        <Grid item>
          <SubTitleContents
            title="Get in Touch with Us"
            contents="We’d love to hear from you! Whether you have a question, need assistance, or want to book our services, feel free to connect with us. We’re here to make the process easy and convenient for you."
          />
        </Grid>
        <Grid
          item
          xs={12}
          lg={1}
          display={"flex"}
          justifyContent={"end"}
          width={"100%"}
          // height={"200px"}
          ml={-3}
          pr={1}
        >
          <MKBox color="primary" display={"flex"} alignItems="center">
            <Icon sx={{ mr: 2 }}>call</Icon>
          </MKBox>
        </Grid>
        <Grid item xs={12} lg={11} display={"flex"} width={"100%"}>
          <MKBox
            display="flex"
            flexDirection="column"
            // pl={2}
            // bgColor="ivory"
            width="100%"
            sx={{ wordbreak: "break-all" }}
          >
            <MKBox>
              <MKTypography variant="h6" color="text" width="100%">
                Call or Text Us
              </MKTypography>
            </MKBox>
            <MKBox>
              <MKTypography variant="body1" color="text">
                (+353) 21 206 3133
              </MKTypography>
            </MKBox>
          </MKBox>
        </Grid>
        {/* <Divider sx={{ width: "100%", my: 1, borderWidth: 2 }} /> */}
        <Grid
          item
          xs={12}
          lg={1}
          display={"flex"}
          justifyContent={"end"}
          width={"100%"}
          // height={"200px"}
          ml={-3}
          pr={1}
        >
          <MKBox color="primary" display={"flex"} alignItems="center">
            <Icon sx={{ mr: 2 }}>mail</Icon>
          </MKBox>
        </Grid>
        <Grid item xs={12} lg={11} display={"flex"} width={"100%"}>
          <MKBox
            display="flex"
            flexDirection="column"
            // pl={2}
            // bgColor="ivory"
            width="100%"
            sx={{ wordbreak: "break-all" }}
          >
            <MKBox>
              <MKTypography variant="h6" color="text" width="100%">
                Email Us
              </MKTypography>
            </MKBox>
            <MKBox>
              <MKTypography component="span" fontWeight="bold">
                <Email
                  email="info@spechs.ie"
                  subject="Inquiry"
                  body="Hello, I have a question about your services."
                >
                  info@spechs.ie
                </Email>{" "}
              </MKTypography>
              {/* <MKTypography variant="body1" color="text">
                info@spechs.ie
              </MKTypography> */}
            </MKBox>
          </MKBox>
        </Grid>
        {/* <Divider sx={{ width: "100%", my: 1, borderWidth: 2 }} /> */}
        <Grid
          item
          xs={12}
          lg={1}
          display={"flex"}
          justifyContent={"end"}
          width={"100%"}
          // height={"200px"}
          ml={-3}
          pr={1}
        >
          <MKBox color="primary" display="flex" alignItems="center">
            <Icon sx={{ mr: 2 }}>person_add</Icon>
          </MKBox>
        </Grid>
        <Grid item xs={12} lg={11} display={"flex"} width={"100%"}>
          <MKBox
            display="flex"
            flexDirection="column"
            // pl={2}
            // bgColor="ivory"
            width="100%"
            sx={{ wordbreak: "break-all" }}
          >
            <MKBox>
              <MKTypography variant="h6" color="text" width="100%">
                Follow Us on Social Media
              </MKTypography>
            </MKBox>
            <MKBox mt={1}>
              <MKBox display="flex" flexDirection="row" alignItems="center">
                <MKTypography
                  component="a"
                  href="https://www.facebook.com/spechs.ie"
                  target="_blank"
                  rel="noreferrer"
                  variant="body1"
                  opacity={0.8}
                  sx={{ mb: 0, pb: 0 }}
                  mr={2}
                  mb={0}
                  pb={0}
                >
                  <FacebookIcon sx={{ mb: 0, pb: 0 }} mb={0} pb={0} />
                </MKTypography>
                <MKTypography
                  component="a"
                  href="https://instagram.com"
                  target="_blank"
                  rel="noreferrer"
                  variant="body1"
                  opacity={0.8}
                  sx={{ mb: 0, pb: 0 }}
                  mr={2}
                  mb={0}
                  pb={0}
                >
                  <InstagramIcon sx={{ mb: 0, pb: 0 }} mb={0} pb={0} />
                </MKTypography>
              </MKBox>
            </MKBox>
          </MKBox>
        </Grid>
        {/* <Divider sx={{ width: "100%", my: 1, borderWidth: 2 }} /> */}
        <Grid
          item
          xs={12}
          lg={1}
          display={"flex"}
          justifyContent={"end"}
          width={"100%"}
          // height={"200px"}
          ml={-3}
          pr={1}
        >
          <MKBox color="primary" display="flex" alignItems="center">
            <WhatsAppIcon sx={{ mr: 2 }} />
          </MKBox>
        </Grid>
        <Grid item xs={12} lg={11} display={"flex"} width={"100%"}>
          <MKBox
            display="flex"
            flexDirection="column"
            // pl={2}
            // bgColor="ivory"
            width="100%"
            sx={{ wordbreak: "break-all" }}
          >
            <MKBox>
              <MKTypography variant="h6" color="text" width="100%">
                Contact Us on WhatsApp
              </MKTypography>
            </MKBox>
            {/* <MKBox>
              <MKTypography variant="body1" color="text">
                https://wa.me/447900929869
              </MKTypography>
            </MKBox> */}
          </MKBox>
        </Grid>
        <Grid
          item
          xs={12}
          lg={1}
          display={"flex"}
          justifyContent={"end"}
          width={"100%"}
          // height={"200px"}
          ml={-3}
          pr={1}
        />
        <Grid item xs={12} lg={11} display={"flex"} width={"100%"}>
          <MKBox
            component="img"
            src={qrCode}
            alt={"QR Code"}
            width="10%"
            display="flex"
            alignItems="center"
            //   mt={2}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default ContactUs_Section1;
